import type { OTCDealData } from '@src/types/OTC';
import { getOtcDealDisplayUser } from '@src/utils/OTC/otcDealDisplayUtils';
import type { ColumnDef } from '@talos/kyoko';
import type { ColDef, ValueGetterParams } from 'ag-grid-community';

export const otcDealUserColumn = {
  id: 'user',
  type: 'custom',
  title: 'User',
  description: 'Talos user shown for the deal (last update, or creator if not set)',
  params: {
    valueGetter: ({ data }: ValueGetterParams<OTCDealData>) => (data ? getOtcDealDisplayUser(data) : undefined),
  } satisfies ColDef<OTCDealData>,
} as const satisfies ColumnDef<OTCDealData>;
